import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = { class: "row gy-xl-4 gy-2" }
const _hoisted_3 = { class: "col-md-12 col-xl-6" }
const _hoisted_4 = { class: "col-md-12 col-xl-6" }
const _hoisted_5 = { class: "col-xl-4 col-md-8 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_FormControl = _resolveComponent("FormControl")!

  return (_openBlock(), _createElementBlock("form", {
    class: "js-form-validation",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    ref: "form",
    "data-form-validation-default-submit": "true"
  }, [
    _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoading }, null, 8, ["loading"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormControl, {
          label: "E-Mail",
          type: "email",
          id: "login-email",
          placeholder: "email.beispiel@beispielmail.ch",
          name: "login-email",
          value: _ctx.loginForm.email,
          modelValue: _ctx.loginForm.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.email) = $event)),
          required: true
        }, null, 8, ["value", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FormControl, {
          label: "Passwort",
          type: "password",
          id: "login-password",
          placeholder: "********",
          name: "login-password",
          value: _ctx.loginForm.password,
          modelValue: _ctx.loginForm.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
          required: true
        }, null, 8, ["value", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-secondary btn-lg w-100",
          type: "submit",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.trackSubmitButtonClick && _ctx.trackSubmitButtonClick(...args)))
        }, "Anmelden")
      ])
    ])
  ], 544))
}